import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Lock } from 'react-feather';
import Checkbox from '../../checkbox/checkbox';
import Icon, { IconSizes } from '../../icon';

const PopoverListItem = ({
  id, name, optional, selected, onSelect,
}) => (
  <div className="ccp-item-cont" key={id}>
    {optional ? (
      <Checkbox
        label={name}
        checked={selected}
        onChange={onSelect(id)}
      />
    ) : (
      <span className="ccp-item-label">
        <Icon icon={Lock} size={IconSizes.SMALL} />
        <span>{name}</span>
      </span>
    )}
  </div>
);

PopoverListItem.defaultProps = {
  id: '',
  name: '',
  optional: false,
  selected: false,
  onSelect: () => {},
};

PopoverListItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  optional: PropTypes.bool,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default memo(PopoverListItem);
